<template>
    <div>
        <div class="icon-with-title">
            <img :src="plugin.image_url" alt="">
            <h3>{{ plugin.name }}</h3>
        </div>
        <p>{{ plugin.description }}</p>
        <a
            v-if="plugin.link"
            :href="plugin.link"
            class="btn"
        >
            Download WordPress Plugin
        </a>
        <div
            v-if="plugin.version"
            href="#"
            class="changelog"
        >
            <a
                href="#"
                @click="showChangelog = true"
            >
                version {{ plugin.version }} (changelog)
            </a>
            <div
                v-if="showChangelog"
                class="modal changelog-modal"
            >
                <div class="modal-content">
                    <base-modal-close
                        @close-modal="showChangelog = ! showChangelog"
                    />
                    <!-- eslint-disable vue/no-v-html -->
                    <div v-html="formatChangelog(plugin.changelog)" />
                    <!-- eslint-enable vue/no-v-html -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        plugin: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        showChangelog: false,
    }),

    methods: {
        /**
         * Formats changelog
         *
         * @param   {string}  str  Unformatted changelog string, with line breaks and unusual signs.
         *
         * @returns  {string}      Formatted string, where '\n' is converted to <br> and content between '**' is converted to <strong>.
         */
        formatChangelog(str) {
            return str.toString().replace(/(\\r)*\\n/g, '<br>').replace(/\*{1,2}(.*?)\*{1,2}/g, '<strong>$1</strong><br>');
        },
    },
};
</script>
